import { render } from "./GestionReporteAcumulado.vue?vue&type=template&id=6e5f5b0d"
import script from "./GestionReporteAcumulado.vue?vue&type=script&lang=js"
export * from "./GestionReporteAcumulado.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__